(function (window, document, undefined) {
  class SaveAnimation {

    static cubicBezier(p0, p1, p2) {
      return function (t) {
        return {
          x: (1 - t) ** 2 * p0.x + 2 * (1 - t) * t * p1.x + t ** 2 * p2.x,
          y: (1 - t) ** 2 * p0.y + 2 * (1 - t) * t * p1.y + t ** 2 * p2.y
        }
      };
    }

    static get defaultOptions() {
      return {
        duration: 750,
        offset: {x: 0, y: 0},
      };
    }

    cancelled = false;
    element = null;
    onDone = null;
    p0 = null;
    p1 = null;
    p2 = null;
    progress = 0;
    startTime = null;

    constructor(options) {
      let {
        duration,
        element,
        offset,
        toElement,
        toElementId
      } = Object.assign(SaveAnimation.defaultOptions, options);

      if (!toElement) {
        toElement = document.getElementById(toElementId);
      }

      if (!toElement) {
        throw new Error('animation target element not specified or found');
      }

      this.duration = duration;
      this.element = element.cloneNode(true);
      this.step = this.step.bind(this);

      // we might need to remove the id of the cloned element and all
      // descendants to avoid collisions
      // this.element.removeAttribute('id');

      const elementBoundingRect = element.getBoundingClientRect();
      const toElementBoundingRect = toElement.getBoundingClientRect();

      // start point
      this.p0 = {
        x: elementBoundingRect.left,
        y: elementBoundingRect.top
      };

      // end point
      this.p2 = {
        x: toElementBoundingRect.left + offset.x,
        y: toElementBoundingRect.top + offset.y
      };

      // control point
      this.p1 = {
        x: this.p0.x + 0.4 * (this.p2.x - this.p0.x),
        y: this.p0.y - 100
      };

      this.bezierCurve = SaveAnimation.cubicBezier(this.p0, this.p1, this.p2);

      Object.assign(this.element.style, {
        left: `${this.p0.x}px`,
        position: 'fixed',
        top: `${this.p0.y}px`,
        willChange: 'transform',
        zIndex: 1001
      });

      document.body.appendChild(this.element);
      requestAnimationFrame(this.step);
    }

    cancel() {
      this.cancelled = true;
    }

    done() {
      document.body.removeChild(this.element);
      
      if (typeof this.onDone === 'function') {
        this.onDone();
      }
    }

    step(timestamp) {
      if (this.cancelled) {
        return this.done();
      }

      if (this.startTime === null) {
        this.startTime = timestamp;
      }

      this.progress = (timestamp - this.startTime) / this.duration;

      const {x, y} = this.bezierCurve(this.progress);

      Object.assign(this.element.style, {
        transform: `translate(${x - this.p0.x}px, ${y - this.p0.y}px)`
      });

      if (this.progress >= 1) {
        this.done();
      } else {
        requestAnimationFrame(this.step);
      }
    }
  }

  window.SaveAnimation = SaveAnimation;
})(window, document);
